import type {
  IDetailsAvatar,
  ITypeOfOptions,
  IAvatarOptionsProps
} from '../../types';

import { useState } from 'react';
import FieldWeight from './FieldWeight';
import { OPTIONS } from '@/utils/common';

import { InputField } from '@CS/components/Form';
import { pushEvent /*, useTranslation */ } from '@CS/hooks';
// import { Content as contentForm } from '@CS/components/Form';

const DetailsAvatar: React.FC<Omit<IAvatarOptionsProps, 'name'>> = ({
  translations,
  setOption,
  setFocus,
  options
}) => {
  const { name, age } = options as IDetailsAvatar;
  const [invalidName, setInvalidName] = useState(false);

  // const { namePlaceholder } = useTranslation(contentForm);
  const validateInput = (value: string) => setInvalidName(!value);

  const onChange = (key: ITypeOfOptions, value: string | number) =>
    setOption(key, value);

  return (
    <>
      <InputField
        last
        value={name}
        maxlength={30}
        name="nameAvatar"
        error={invalidName}
        setFocus={setFocus}
        label={translations.person_name}
        fieldError={translations.person_name_error}
        placeholder={translations.person_name_container}
        onClick={() => {
          pushEvent({
            event: 'button_click',
            eventAction: 'Naam familie lid',
            eventLabel: '/fam-mode-2/creating-avatars/customization'
          });
        }}
        onBlur={() => {
          validateInput(name);
        }}
        onChange={(event) => {
          const target = event.target;
          const value = target.value;

          validateInput(value);
          onChange(OPTIONS.name, value);
        }}
      />

      <FieldWeight
        value={age}
        label={translations.person_length}
        onChange={(value) => {
          onChange(OPTIONS.age, value);
        }}
      />
    </>
  );
};

export default DetailsAvatar;
